module.exports = __webpack_public_path__ + "static/events-image-hero-7b4ff757cb5b0bbccd1b38bdc0f31c81.png";